import React from "react";
import { Dialog } from "@vitalsource/vstui";
import { connect } from "react-redux";
import Reveal from "../icons/courseware/reveal";
import Visit from "../icons/courseware/visit";
import styled from "styled-components";
import { t, Translation } from "../../../core/translate";
import {
  actions as ancillaryActions,
  selectors as ancillarySelectors
} from "../../../../redux/ancillaries";
import { actions as modalActions } from "../../../../redux/modals";
import { selectors as booksSelectors } from "../../../../redux/books";
import { actions as bookActions } from "../../../../redux/book";
import InputButton from "../../../components/input-button";
import { toastUtils } from "../../../../utils/toast-utils";
import { cloud } from "@vitalsource/vstui/colors";

const DialogContent = styled.div`
  svg {
    float: left;
    margin-right: 25px;
  }
  a {
    margin: 10px 0 25px 0;
    display: block;
  }
  & > span {
    float: right;
    position: absolute;
    right: 24px;
    bottom: 24px;
    z-index: 3;
  }
`;

const ReturnNote = styled.div`
  font-size: 1.3rem;
  padding-top: 25px;
  color: ${cloud.getShade(7)};
`;

const ReturnPolicy = styled.div`
  padding: 10px 0;
  font-size: 1.6rem;
  a {
    display: inline;
    margin: 0;
    font-size: 1.6rem;
  }
`;

class RevealModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stepOne: true,
      stepTwo: false
    };
  }

  copyAccessCode = () => {
    const resource = this.props.accessCode;
    const result = Fraction.Helpers.copyText(resource.code || "");
    if (result) {
      toastUtils.notify(
        t("eresources.access-code-copied", "Access Code Copied"),
        { type: "success" }
      );
    } else {
      toastUtils.notify(t("errors.copy-failed"), { type: "error" });
    }
  };

  renderContent() {
    if (this.state.stepOne) {
      const policyLink =
        Fraction.Brand.ReturnPolicy.url ||
        i18n.t("locations.zendesk-return-privacy");
      return (
        <DialogContent>
          <Reveal />
          <ReturnPolicy>
            <Translation id="eresources.reveal-warning" link={policyLink} html>
              Please review the relevant return policy before revealing your
              code.
            </Translation>
          </ReturnPolicy>
          <ReturnNote>
            <Translation id="eresources.intentions" isbn={this.props.isbn} html>
              Courseware is often assigned by an instructor.This product’s ISBN
              is '#ISBN', make sure this is what’s intended before continuing.
            </Translation>
          </ReturnNote>
        </DialogContent>
      );
    }
    if (this.state.stepTwo) {
      return (
        <DialogContent>
          <Visit />
          <InputButton
            id="AccessCode"
            inputProps={{
              label: t("eresources.access-code", "Access Code"),
              onChange: () => {},
              readOnly: true,
              value:
                this.props.accessCode.code ||
                (this.props.accessCode.isRedeeming
                  ? t(
                      "eresources.access-code-redeeming",
                      "Redeeming Access Code..."
                    )
                  : t("base.error", "Error"))
            }}
            buttonProps={{
              onClick: this.copyAccessCode,
              disabled:
                !Fraction.Helpers.copyEnabled() || !this.props.accessCode.code
            }}
          >
            <Translation id="base.copy">Copy</Translation>
          </InputButton>
        </DialogContent>
      );
    }
  }

  getPrimaryButtonText() {
    if (this.state.stepOne) {
      return t("eresources.reveal-access-code", "Reveal Access Code");
    } else if (this.state.stepTwo) {
      if (this.props.accessCode.href) {
        return t("eresources.visit-website", "Visit Website");
      } else {
        return t("library.open-book", "Open Book");
      }
    }
  }

  primaryButtonAction = () => {
    if (this.state.stepOne) {
      this.props.redeemAncillary(this.props.isbn);
      this.setState({ stepOne: false, stepTwo: true });
    } else if (this.state.stepTwo) {
      if (this.props.accessCode.href) {
        window.open(this.props.accessCode.href, "_blank");
      } else {
        this.props.launchBook();
      }
      this.props.closeModal();
    }
  };

  render() {
    const { closeModal, book } = this.props;
    const bookTitle = decodeURIComponent(book.title);
    return (
      <Dialog
        onRequestClose={closeModal}
        rootSelector="#bookshelf"
        title={bookTitle}
        secondaryActionButton={{
          label: t("base.cancel", "Cancel"),
          onClick: closeModal
        }}
        primaryActionButton={{
          label: this.getPrimaryButtonText(),
          onClick: this.primaryButtonAction
        }}
        open
        size="large"
        darkHeader
      >
        {this.renderContent()}
      </Dialog>
    );
  }
}
const mapStateToProps = (state, props) => ({
  book: booksSelectors.getBookByIsbn(state, props.isbn),
  accessCode: ancillarySelectors.getAccessCodesForVbid(state, props.isbn)
});

const mapDispatchToProps = (dispatch, props) => ({
  redeemAncillary: isbn => dispatch(ancillaryActions.redeemAncillary(isbn)),
  closeModal: () => dispatch(modalActions.closeModal()),
  launchBook: () => dispatch(bookActions.launchLicensedBook(props.isbn))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RevealModal);
